var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path.trim().startsWith('/top-sales'))?_c('div',[_c('router-view')],1):_c('div',[(_vm.$store.state.user)?_c('app-nav'):_vm._e(),_c('router-view'),_c('cc-profile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }